import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/useEntity';

/** Fotos principales de todos los productos del cliente (URLs firmadas 1 h). */
export function useFotosCatalogo(clienteCodigo?: string) {
  const qs = clienteCodigo ? `?cliente_codigo=${encodeURIComponent(clienteCodigo)}` : '';
  return useQuery({
    queryKey: ['catalogo-fotos', clienteCodigo ?? '*'],
    queryFn: async () => {
      const r = await api.get<{ data: Record<string, string>; proveedor?: string[] }>(`/catalogo/fotos${qs}`);
      return { urls: r.data, proveedor: new Set(r.proveedor ?? []) };
    },
    staleTime: 30 * 60_000,
  });
}
